var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simple-graph"},[_c('svg',{staticClass:"render",attrs:{"viewBox":"0 0 100 100","preserveAspectRatio":"none"}},[_c('path',{staticClass:"path",attrs:{"d":_vm.path}})])])}
var staticRenderFns = []

export { render, staticRenderFns }